import * as React from 'react';
import { defaultKeyboardContext, defaultKeyboardValues } from './KeyboardProvider';
export const KeyboardContext = /*#__PURE__*/React.createContext({ ...defaultKeyboardContext,
  ...defaultKeyboardValues
});
//# sourceMappingURL=KeyboardContext.js.map